<div class="toggle-switch">
  <label
    (click)="toggleChecked(); $event.stopPropagation()"
    [ngClass]="{'checked' : checkedSignal()}">
    <span></span>
  </label>
</div>
